import React from "react";

export function ModalRescheduleConfirm({ onClose, onConfirm }) {
  return (
    <>
      <div className="overlay"></div>
      <div
        id="filterModal"
        role="dialog"
        className="modal fade in displayBlock"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                onClick={onClose}
              >
                ×
              </button>
              <h4 className="modal-title" id="model_title">
                Are You Sure?
              </h4>
            </div>
            <div
              id="errorwindow"
              className="modal-body add-patient-form filter-patient"
            >
              Are you sure want to reschedule this event?
            </div>
            <div className="modal-footer">
              <div className="col-md-12 text-left" id="footer-btn">
                <button
                  type="button"
                  className="btn  logout pull-right"
                  data-dismiss="modal"
                  onClick={onClose}
                >
                  No
                </button>
                <button
                  type="button"
                  className="btn btn-success pull-right m-r-10"
                  data-dismiss="modal"
                  onClick={onConfirm}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
